export default {
    cantico: {
      title: 'Il Cantico delle Creature',
      subtitle: 'di San Francesco d\'Assisi',
      headerOriginal: 'Lingua originale del 1225',
      headerTranslations: 'Versione in polacco',
      text: `Najwyższy, wszechmogący, dobry Panie, Twoja
jest chwała, chwała, cześć i wszelkie
błogosławieństwa. Do Ciebie
tylko, Najwyższy, się one odnoszą i żaden
człowiek nie jest Twojego godzien.

Pochwalony bądź, mój Panie, za wszystkie
stworzenia, a szczególnie przez Brata Słońce,
które przynosi dzień, który nas oświetla, a jest
on piękny promienny wielkim blaskiem: od
Ciebie, Najwyższy, niesie znaczenie.

Pochwalony bądź, mój Panie, za Siostrę Księży i
Gwiazdy: na niebie stworzyłeś je czyste, piękne
i cenne.

Pochwalony bądź, mój Panie, za Brata Wiatr i
za Powietrze, Chmury, czyste Niebo i wszelką
pogodę, przez którą dajesz pożywienie swoim
stworzeniom.

Pochwalony bądź, mój Panie, za Siostrę Wodę,
która jest bardzo pożyteczna, pokorna, cenna i
czysta.

Pochwalony bądź, mój Panie, przez Brata
Ogień, którym rozświetlasz noc: a On jest silny,
piękny, silny i radosny.

Chwała Tobie, mój Panie, za naszą Matkę
Ziemię, tóra nas podtrzymuje i rządzi nami, i
wydaje różnorodne owoce z barwnymi
kwiatami i ziołami.

Chwała Tobie, mój Panie, za tych, którzy
przebaczają za Twoją miłość i znoszą choroby i
cierpienia.

Błogosławieni, którzy znoszą je w pokoju, bo
przez Ciebie zostaną ukoronowani.

Chwała Tobie, mój Panie, za naszą siostrę,
śmierć cielesną, przed którą żaden żyjący
człowiek nie może uciec.

Biada tym, którzy umierają w grzechu
śmiertelnym. Błogosławieni, którzy są w Twojej
woli, bo śmierć nie wyrządzi im krzywdy.

Chwała i błogosław Pana, i dziękuj Mu, i
służ Mu z wielką pokorą.`
    }
  }